export interface IImage {
  id?: number;
  name?: string | null;
}

export const defaultValue: Readonly<IImage> = {};
